<template>
    <div class="summary-box">
        <div class="summary-box-title">
            <slot></slot>
            <span>
                {{ $t(titleString) }}
            </span>
        </div>
        <ChartDoughnut :chartData="chartData" :width="size" :height="size" class="chart" />
    </div>
</template>

<script>
import ChartDoughnut from './components/ChartDoughnut'

export default {
    props: {
        chartData: {
            type: Object,
            required: true,
        },
        titleString: {
            type: String,
            default: '',
        },
    },
    components: {
        ChartDoughnut,
    },
    computed: {
        size() {
            if (window.matchMedia('(max-width: 48em)').matches) {
                return 40
            } else if (window.matchMedia('(max-width: 96em)').matches) {
                return 35
            } else {
                return 45
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.summary-box {
    display: flex;
    justify-content: space-between;
    width: 100%;
    border: 1px solid #c2c5c9;
    border-radius: 5px;
    padding: 5px 10px;
    align-items: center;
}
.summary-box-title {
    display: flex;
    align-items: center;
    min-width: 83px;
}

@media only screen and (max-width: 60em) {
    .summary-box {
        width: 100% !important;
        justify-content: space-between !important;
    }
    .summary-box-title span {
        padding-left: 5px;
    }
}

@media only screen and (max-width: 96em) {
    .summary-box {
        width: calc(53% - 10px);
        justify-content: space-evenly;
    }
    .chart {
        margin-left: 10px;
    }
}
</style>
